import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(
    private confirmationService: ConfirmationService
  ) { }

   confirm(
    message: string,
    header: string = 'Confirmation',
    icon: string = 'pi pi-exclamation-triangle'
  ): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationService.confirm({
        message,
        header,
        icon,
        accept: () => resolve(true),
        reject: () => resolve(false)
      });
    });
  }
  
}
